module.exports = function (app) {
    app.controller("bdcController", ['$scope', 'sessionData', 'modal', '$window', 'services', '$filter', '$state', 'brandConfig',
        function ($scope, sessionData, modal, $window, services, $filter, $state, brandConfig) {
        var disclaimerModal = require('./json/bdcDisclaimer.json');
        disclaimerModal.classes = 'width-80';
        modal.open(disclaimerModal);
        //window.$scope=$scope;
        $scope.content = require('./json/bdcContent.json');
        $scope.specialtyContent = require('./json/bdSpecialtiesContent.json');
        $scope.benefitsOverview = {};
        $scope.copayFlavorListItems=[];
        $scope.isExtended =true;
        $scope.extend = function(){
            if($scope.isExtended == true){
                document.getElementById("arrowDropdown").className = "bdc-carat icon-black-single-arrow-right";
                $scope.isExtended = false;
            }
            else{
                document.getElementById("arrowDropdown").className = "bdc-carat icon-black-single-arrow-down";
                $scope.isExtended =true;}
        };

        var currentYear = new Date().getFullYear();
        // Get Benefit Grid
        services.rbsbdc.memberService().fetch({
            userName: sessionData.userName,
            group: sessionData.groupNumber,
            targetSite: sessionData.memberInfo.brand.toLowerCase()
        }).then(function (res) {
            //            var benefitGridData = results[0][1],
            $scope.member = res.data;


                var i;
            for (i in $scope.member.memberPlanData ) {
                if ($scope.member.memberPlanData.hasOwnProperty(i)){
                    var planData = $scope.member.memberPlanData[i];
                    if (planData.visionCoverage === "true") {
                        planData.iconType = "vision";
                    } else if (planData.dentalCoverage === "true") {
                        planData.iconType = "dental";
                    } else if (planData.pharmacyCoverage === "true") {
                        planData.iconType = "pharmacy";
                    } else if (planData.medicalCoverage === "true") {
                        planData.iconType = "medical";
                    } else {
                        planData.iconType = "medical";
                    }

                    if ($scope.member.isVerified == 'Y') {

                        //planName = planData.planName;

                        var clientList = [];
                        var groupList = [];
                        var eobGrpNum = '';
                        var mbrInfoObjData = sessionData.memberInfo;
                        if (mbrInfoObjData !== null) {


                            clientList = mbrInfoObjData.clientList;
                            if (clientList !== null) {

                                for (var j = 0; j < clientList.length; j++) {
                                    groupList = clientList[j].groupList;
                                }

                                for (var k = 0; k < groupList.length; k++) {
                                    if (planData.groupNumber == groupList[k].groupNumber) {
                                        eobGrpNum = groupList[k].idCardEobGroupNumber;
                                        break;
                                    }

                                }

                            }

                        }

                        if (eobGrpNum !== null && eobGrpNum !== "") {
                            planData.groupNo = eobGrpNum;
                        } else {
                            planData.groupNo = planData.groupNumber;
                        }
                    }
                }}
        });


        services.rbsbdc.getBooklet().fetch(sessionData.userName).then(function (res) {
            $scope.benefitBooklets = res.data;

            //                benefitBookData = results[1][1],
        });
        services.rbsbdc.getVideos().fetch({
            userName: sessionData.userName
        }).then(function (res) {
            $scope.videos = res.data;

            //                coverageVideosData = results[2][1],
        });

        services.rbsbdc.getSpecialties().fetch(sessionData.userName,sessionData.groupNumber).then(function (res) {
            //            buildBdSpecialties(bdSpecialtiesData);
            $scope.specialties = res.data.designations[0].specialties;
            var planFlavor = res.data.copayFlavor;
            if (planFlavor == null || planFlavor == undefined){
                //planFlavor = ['Else'];
                $scope.copayFlavorListItems.push($scope.content.copayFlavor.Else);
            }else{
                $scope.copayFlavorListItems.push($scope.content.copayFlavor[planFlavor]);


            }
        }, function(error){
            $scope.copayFlavorListItems.push($scope.content.copayFlavor.Else);
        });


        services.rbsbdc.getBenefitGrid().fetch({
            userName: sessionData.userName
        }).then(function (res) {
            //            var benefitGridData = results[0][1],
            $scope.benefitGrid = res.data;

            $scope.benefitGridUrl=[];
            if($scope.benefitGrid.length >0){
            for (var a=0; a < $scope.benefitGrid.length; a++) {
                $scope.benefitGridUrl[a] = "/rbsbdc/x-services/getPdf?userName=" + sessionData.userName + '&fileName='+ $scope.benefitGrid[a][a].fileName;
            }}
        }, function(error){
            $scope.benefitGrid.length = 0;
        });

        $scope.dateFormattedBDC = function (dateString) {
            if (dateString === '00-00-0000') return '*';
            return $filter('date')(new Date(dateString), 'MMM d, yyyy');
        };


        $scope.openSpecialtiesModal = function (specialty) {

            modal.open({
                template: '<h3>{{special}}</h3> <hr class="thick"><p>{{specialtyContent.header}}</p>' +
                '<ul class="list-bullets"><li data-ng-repeat="specialty in specialtyContent.servicesList">{{specialty}}</li>' +
                '</ul><p>{{specialtyContent.footer}}</p>',
                controller: ["$scope", function ($scope) {
                    var content = require('./json/bdSpecialtiesContent.json');
                    $scope.special = specialty;
                    $scope.specialtyContent = content[specialty];
                }]
            });
        };

        $scope.bytesToSize = function (bytes, precision) {
            var kilobyte = 1024,
                megabyte = kilobyte * 1024,
                gigabyte = megabyte * 1024,
                terabyte = gigabyte * 1024;

            if ((bytes >= 0) && (bytes < kilobyte)) {
                return bytes + ' B';
            }

            if ((bytes >= kilobyte) && (bytes < megabyte)) {
                return (bytes / kilobyte).toFixed(precision) + ' KB';
            }

            if ((bytes >= megabyte) && (bytes < gigabyte)) {
                return (bytes / megabyte).toFixed(precision) + ' MB';
            }

            if ((bytes >= gigabyte) && (bytes < terabyte)) {
                return (bytes / gigabyte).toFixed(precision) + ' GB';
            }

            if (bytes >= terabyte) {
                return (bytes / terabyte).toFixed(precision) + ' TB';
            }

            return bytes + ' B';
        };

        $scope.findADoctorLink = function () {

            var brand = brandConfig.getBrandFromDomain();
            switch (brand.ubk) {
                case 6010:
                    window.location = '/find-a-doctor/home';
                    break;
                default:
                    $state.go('finder');
            }
        };
        //END OF CONTROLLER
    }]);
};
